import PropTypes from "prop-types";
import { Input, Label } from "react-aria-components";
import { useFormState } from "react-hook-form";

import { BaseAriaFormController } from "../../../../components/BaseComponents/BaseAriaFormController";
import { forwardRefComponent } from "../../../../helpers/forwardRefComponent";
import { twMerge } from "../../../../helpers/twMerge";

export const TextFieldControllerComponent = ({
	name,
	label,
	ref,
	className,
	...rest
}) => {
	const { errors } = useFormState({ name });
	const error = errors[name];

	return (
		<BaseAriaFormController
			className={twMerge(
				"tw:relative tw:flex tw:w-full tw:max-w-[50%] tw:flex-col tw:max-lg:max-w-full",
				className,
			)}
			name={name}
			{...rest}
		>
			<Label className="tw:sr-only">{label}</Label>
			<Input
				className={`tw:arrow-hide tw:w-full tw:rounded-lg tw:border-2 tw:border-solid tw:border-[#E4E4E5] tw:bg-white tw:px-3.5 tw:py-2.5 tw:text-base tw:leading-6 tw:font-semibold tw:placeholder:text-[#747481] tw:invalid:ring-3 tw:invalid:ring-red-500/50 tw:focus:border-[#3182ce] tw:focus:ring-3 tw:focus:ring-blue-500/50 tw:focus-visible:ring-3 tw:focus-visible:ring-blue-500/50 tw:focus-visible:invalid:ring-3 tw:focus-visible:invalid:ring-blue-500/50 ${
					error ? "tw:ring-3 tw:ring-red-500/50" : ""
				}`}
				ref={ref}
			/>
		</BaseAriaFormController>
	);
};

TextFieldControllerComponent.propTypes = {
	name: PropTypes.string.isRequired,
	label: PropTypes.string.isRequired,
	error: PropTypes.object,
	ref: PropTypes.object,
	className: PropTypes.string,
};

export const TextFieldController = forwardRefComponent(
	TextFieldControllerComponent,
);
